import {useEffect, useRef} from 'react'
import gsap from 'gsap'

export default function AnimatedTitle() {
  const lettersRef = useRef([]);

  useEffect(() => {
    // Inicializace GSAP animace pro každé písmeno
    lettersRef.current.forEach((letter, i) => {
      const rand1 = Math.random()
      const rand2 = Math.random()
      const rand3 = Math.random()
      const rand4 = Math.random()

      gsap.fromTo(
        letter,

        {
          y: (30 + Math.floor(rand1 * 250)) * (rand4 < 0.5 ? -1 : 1),
          scale: 3 + rand2 * 2,
          filter: "blur(3px)",
        },
        {
          y: 0,
          scale: 1,
          filter: "blur(0px)",
          delay: 0.8 + rand2, // náhodná rychlost
          duration: 2 + rand3 * 3,
          ease: "power4.out"
        }
      );

      gsap.fromTo(
        letter,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          delay: 0.3 + rand2, // náhodná rychlost
          duration: 2 + rand3 * 3,
          ease: "power1.inOut"
        }
      );



    });
  }, []);

  const title = "TRAILS OF ICE AND FIRE";

  return (
    <span className="text-4xl md:text-6xl font-bold flex flex-wrap justify-center gap-x-1">
      {title.split("").map((char, index) => (
        <span
          key={index}
          ref={(el) => (lettersRef.current[index] = el)}
          className="dib"
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </span>
  );
}